<script setup lang="ts">
import qiniuLogo from '~/assets/brands/qiniu.png'
import aliyunLogo from '~/assets/brands/aliyun-icon.webp'

const props = defineProps<{
  values: Record<string, any>
  siteName: string
}>()

const currentYear = new Date().getUTCFullYear()
const footerLinks = computed(() => [1, 2, 3]
  .map((index) => ({ text: props.values[`footer_link_${index}_text`] || '', url: props.values[`footer_link_${index}_url`] || '' }))
  .filter((item) => item.text && item.url))
</script>

<template>
  <footer class="home-footer border-t py-8 text-center text-xs text-[#94a3b8]">
    <div class="mx-auto flex w-full max-w-[1280px] flex-col items-center gap-2 px-4 sm:px-6 lg:px-8 xl:px-0">
      <p class="footer-copyright">{{ values.footer_copyright || `© ${currentYear} ${values.site_title || siteName} · 记录每一次思考` }}</p>
      <p v-if="values.footer_info_text" class="footer-detail">{{ values.footer_info_text }}</p>
      <div class="footer-brands" aria-label="基础设施服务">
        <span class="footer-brand-group"><span>CDN 驱动</span><img class="footer-brand-logo footer-brand-qiniu" :src="qiniuLogo" alt="七牛云" width="32" height="32" /></span>
        <span class="footer-brand-separator" aria-hidden="true">·</span>
        <span class="footer-brand-group"><span>服务驱动</span><img class="footer-brand-logo footer-brand-aliyun" :src="aliyunLogo" alt="阿里云" width="32" height="32" /><span class="footer-brand-name">阿里云</span></span>
        <span class="footer-brand-separator" aria-hidden="true">·</span>
        <span class="footer-brand-group footer-brand-samwaf"><span>安全驱动</span><AppIcon name="shield-check" class="footer-brand-icon" /><span class="footer-brand-name">SamWAF</span></span>
      </div>
      <div v-if="footerLinks.length || values.footer_powered_name || values.footer_icp || values.footer_police" class="footer-meta">
        <a v-for="item in footerLinks" :key="item.url" :href="item.url" target="_blank" rel="noopener noreferrer">{{ item.text }}</a>
        <a v-if="values.footer_powered_name && values.footer_powered_url" :href="values.footer_powered_url" target="_blank" rel="noopener noreferrer">{{ values.footer_powered_name }}</a>
        <span v-else-if="values.footer_powered_name">{{ values.footer_powered_name }}</span>
        <a v-if="values.footer_icp && values.footer_icp_url" :href="values.footer_icp_url" target="_blank" rel="noopener noreferrer">{{ values.footer_icp }}</a>
        <span v-else-if="values.footer_icp">{{ values.footer_icp }}</span>
        <a v-if="values.footer_police && values.footer_police_url" :href="values.footer_police_url" target="_blank" rel="noopener noreferrer">{{ values.footer_police }}</a>
        <span v-else-if="values.footer_police">{{ values.footer_police }}</span>
      </div>
    </div>
  </footer>
</template>
